export function generateRandomString(length = 16): string {
  // Calculate how many bytes we need to generate to get the desired length
  // Base64 encoding converts 3 bytes to 4 characters, so we need to generate
  // enough bytes to get at least the desired length after encoding
  const bytesNeeded = Math.ceil((length * 3) / 4)
  const bytes = new Uint8Array(bytesNeeded)
  crypto.getRandomValues(bytes) // Secure random values

  // Convert bytes to a Base64 string (compatible with Edge runtime)
  const base64 = Buffer.from(bytes).toString('base64')

  // Convert to URL-safe Base64 and trim to exact length
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
    .slice(0, length)
}
